export enum BadgeType {
    DEFAULT = 'default',
    INFO = 'info',
    WARNING = 'warning',
    HIGHLIGHT = 'highlight',
    ERROR = 'error',
    ALERT = 'alert',
    SUCCESS = 'success',
}

export type ExtendedBadgeProps = {
    /** Additional class to the component */
    className?: string;
};
